import { useQuery } from '@apollo/client/react';

import { GET_MAP } from '@atom/graph/map';
import { usePreferences } from '@atom/hooks/usePreferences';
import { EMPTY_MAP_DATA } from '@atom/map';
import { MapData, MapInput } from '@atom/types/map';

type UseTeamMapDataArgs = {
  coordinates: string;
  zoomLevel: number;
};

export const useTeamMapData = ({
  coordinates,
  zoomLevel,
}: UseTeamMapDataArgs): [MapData, boolean] => {
  const clusterDensity = usePreferences().map?.clusterDensity ?? 'default';

  const input: MapInput = {
    coordinates: coordinates ? (JSON.parse(coordinates) as number[][][]) : [],
    zoomLevel,
    clusterDensity,
    includeUsers: true,
    includeAssets: false,
    includeWorkOrders: false,
  };

  const { data, previousData, loading } = useQuery(GET_MAP, {
    variables: { input },
    skip: !coordinates,
    fetchPolicy: 'network-only',
  });

  return [data?.map ?? previousData?.map ?? EMPTY_MAP_DATA, loading];
};
